// extracted by mini-css-extract-plugin
export default {"return":"p3xYSdQSXSsu72d0Q2S9","logos":"ZRDxLxTj7PYvemEc2fVj"};